import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { DatePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { VacationRequestsPopupComponent } from './vacation-requests-grid/vacation-requests-popup/vacation-requests-popup.component';
// ExcelExportService: the request popup's Impacts tree grid (still Syncfusion) exports to Excel.
import { ExcelExportService } from '@syncfusion/ej2-angular-grids';
import { Grid as InavistaGrid } from '@inavista/components/grid';
// import { SharedModule } from '../../shared/shared.module';
import { NumericTextBoxModule, TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import { MatDividerModule } from '@angular/material/divider';
import { ReactiveFormsModule } from '@angular/forms';

import { VacationRequestsGridComponent } from './vacation-requests-grid/vacation-requests-grid.component';
import { VacationsRequestRoutingModule } from './vacations-request.routing.module';
import { VacationRequestService } from './vacation-request.service';
import { OtherVacationsPopupComponent } from './vacation-requests-grid/vacation-requests-popup/other-vacations-popup/other-vacations-popup.component';
import { VrResourcesPopupComponent } from './vacation-requests-grid/vacation-requests-popup/vr-resources-popup/vr-resources-popup.component';
import { AttachmentsComponent } from 'projects/shared/src/lib/components/attachments/attachments.component';
import { HistoryComponent } from 'projects/shared/src/lib/components/history/history.component';
import { LinksComponent } from 'projects/sales/src/app/shared/components/links/links.component'
// The Impacts tree grid's column chooser.
import { ColumnChooserComponent } from '../../components/column-chooser/column-chooser.component';
import { PopupHeaderComponent } from '../../components/popup-header/popup-header.component';
import { UserProfileModule } from 'projects/sales/src/app/modules/user-profile/user-profile.module';


@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FlexLayoutModule,
    VacationsRequestRoutingModule,
    MatDividerModule,
    // SharedModule,
    NumericTextBoxModule,
    DateTimePickerModule,
    DropDownListModule,
    TextBoxModule,
    DatePickerModule,
    TreeGridModule,
    InavistaGrid,
    AttachmentsComponent,
    HistoryComponent,
    UserProfileModule,
    LinksComponent,
    ColumnChooserComponent,
    PopupHeaderComponent
  ],
  declarations: [
    VacationRequestsGridComponent,
    VacationRequestsPopupComponent,
    OtherVacationsPopupComponent,
    VrResourcesPopupComponent
  ],
  providers: [
    ExcelExportService,
    VacationRequestService
  ],
  exports: [
    VacationRequestsPopupComponent,
    OtherVacationsPopupComponent,
    VrResourcesPopupComponent
  ]
})
export class VacationsRequestModule { }
